export const jumpToButtonLabel = "zWrEib";
export const goButtonLabel = "ereW3b";
export const goButtonLabelDateTimeSort = "blwDMd";
export const jumpToDatePickerLabel = "bvfvU";
export const jumpToSenderInputPlaceholder = "jnjTLe";
export const jumpToSubjectInputPlaceholder = "I$t1kc";
export const jumpToRecipientInputPlaceholder = "dbqnue";
export const importanceNormal = "jBI75";
export const importanceLow = "GWeH0c";
export const importanceHigh = "ud1qWb";
export const dateToday = "b71ytd";
export const dateYesterday = "eOmWc";
export const dateLastWeek = "ENpzEe";
export const dateLastMonth = "spTlbe";
export const dateLastYear = "fQpqDb";
export const sizeTinyOption = "MiY0Ke";
export const sizeSmallOption = "pILUdd";
export const sizeMediumOption = "dSRdfe";
export const sizeLargeOption = "fFV$yc";
export const sizeVeryLargeOption = "Nl5Mie";
export const sizeHugeOption = "ToZsSb";
export const sizeEnormousOption = "Qu198";
export const categoryNoneOption = "lWt0r";
export default {jumpToButtonLabel,goButtonLabel,goButtonLabelDateTimeSort,jumpToDatePickerLabel,jumpToSenderInputPlaceholder,jumpToSubjectInputPlaceholder,jumpToRecipientInputPlaceholder,importanceNormal,importanceLow,importanceHigh,dateToday,dateYesterday,dateLastWeek,dateLastMonth,dateLastYear,sizeTinyOption,sizeSmallOption,sizeMediumOption,sizeLargeOption,sizeVeryLargeOption,sizeHugeOption,sizeEnormousOption,categoryNoneOption};